export default "__VITE_ASSET__DWabik2C__"